import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from "@angular/core";
import { IncidentListService } from "../../_services/incident-list.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";

@Component({
  selector: "incident-list",
  templateUrl: "./incident-list.component.html",
  styleUrls: ["./incident-list.component.css"],
})
export class IncidentListComponent implements OnInit, OnChanges {
  @Input() planningId: number;
  @Input() companyId: number;
  @Output() created: EventEmitter<number> = new EventEmitter<number>();

  private incidents: object[];
  private creating: boolean = false;

  new_incident = new FormGroup({
    source: new FormControl(),
    content: new FormControl("", [Validators.required]),
  });

  constructor(private service: IncidentListService) {}

  ngOnInit() {
    this.getIncidentList();
  }

  ngOnChanges() {
    this.getIncidentList();
  }

  getIncidentList() {
    //console.log("list only =" + this.listOnly);
    this.service.getIncidents(this.planningId).subscribe((response) => {
      this.incidents = response;
    });
  }

  editIncident(event) {
    event.target.parentElement.getElementsByClassName(
      "no-edit-incident"
    )[0].style = "display: none;"; // Hide the displayed Task
    event.target.parentElement.getElementsByClassName(
      "edit-incident"
    )[0].style = "display: auto;"; // Show it's edit Form
    event.target.parentElement
      .getElementsByClassName("edit-incident")[0]
      .getElementsByTagName("INPUT")[0]
      .focus(); // Focus the Input
    event.target.parentElement
      .getElementsByClassName("edit-incident")[0]
      .getElementsByTagName("INPUT")[0]
      .select(); // Select the content to direct edit
  }

  validEdit(event) {
    if (event.keyCode === 13) {
      // If ENTER pressed, trigger the click on the Update button
      event.target.parentElement.getElementsByTagName("BUTTON")[0].click();
    }
  }

  addIncident(event) {
    this.creating = true;
  }

  createIncident(event) {
    this.service
      .createIncident({
        id: this.planningId,
        content: this.new_incident.value.content,
        source: this.new_incident.value.source,
        company_id: this.companyId
      })
      .subscribe((response) => {
        this.getIncidentList();
        this.new_incident.patchValue({ content: "",source: '' });
        event.target.parentElement.parentElement.style = "display: none;";
        this.created.emit(this.incidents.length);
        this.creating = false;
      });
  }

  deleteIncident(incident_id: number) {
    this.service.deleteIncident(incident_id).subscribe((response) => {
      this.getIncidentList();
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/incident-list/incident-list.component.ts